import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { TranslocoService } from "@jsverse/transloco";
import { SidenavInterface } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-pages",
  template: `<div *transloco="let t">
      @if (logged) {
        <div class="dark h-screen w-screen bg-tertiary flex ">
          <std-sidenav
            [expanded]="isMenuOpen"
            childrenType="secondary"
            (onChangeExpanded)="menuChanged($event)"
            primaryColor="var(--primary)"
            secondaryColor="var(--secondary)"
            (menuClick)="goTo($event)"
            [showScrollbar]="false"
            [menuItems]="menuItems"
            textClass="text-white"
            closeMenuClass="text-primary h-[45px]"
            (userClick)="userClick()"
            [userInfo]="userInfo"
            [closeMenu]="t('closeMenu')"
            customIconClass="w-[65%]"
            mobileOpenMenuClass="top-[24px] left-[calc(100vw-48px)] hidden"
            >
            <div
              title
              class="text-[26px] h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
              >
              <img class="cursor-pointer" (click)="goToHome()" src="../assets/logo.png" />
            </div>
            <div
              subTitle
              class="text-[26px] h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
              >
              <img class="cursor-pointer" (click)="goToHome()" src="../assets/logo.png" />
            </div>
          </std-sidenav>
          <div class="w-full h-screen">
            <div class="h-20 bg-tertiary shadow-lg items-center pl-4 flex">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 15 15" fill="none"><g clip-path="url(#clip0_397_432)"><path d="M7.66289 2.96687C7.61927 2.92514 7.56124 2.90186 7.50088 2.90186C7.44052 2.90186 7.38248 2.92514 7.33887 2.96687L1.94531 8.11931C1.92241 8.14122 1.90418 8.16755 1.89175 8.1967C1.87931 8.22586 1.87291 8.25724 1.87295 8.28894L1.87207 13.1247C1.87207 13.3733 1.97084 13.6118 2.14666 13.7876C2.32247 13.9634 2.56093 14.0622 2.80957 14.0622H5.625C5.74932 14.0622 5.86855 14.0128 5.95646 13.9249C6.04436 13.837 6.09375 13.7177 6.09375 13.5934V9.60905C6.09375 9.54689 6.11844 9.48728 6.1624 9.44333C6.20635 9.39937 6.26596 9.37468 6.32812 9.37468H8.67188C8.73404 9.37468 8.79365 9.39937 8.8376 9.44333C8.88156 9.48728 8.90625 9.54689 8.90625 9.60905V13.5934C8.90625 13.7177 8.95564 13.837 9.04354 13.9249C9.13145 14.0128 9.25068 14.0622 9.375 14.0622H12.1893C12.4379 14.0622 12.6764 13.9634 12.8522 13.7876C13.028 13.6118 13.1268 13.3733 13.1268 13.1247V8.28894C13.1268 8.25724 13.1204 8.22586 13.108 8.1967C13.0955 8.16755 13.0773 8.14122 13.0544 8.11931L7.66289 2.96687Z" fill="var(--primary)"></path><path d="M14.3821 7.15283L12.1907 5.05635V1.875C12.1907 1.75068 12.1414 1.63145 12.0534 1.54354C11.9655 1.45564 11.8463 1.40625 11.722 1.40625H10.3157C10.1914 1.40625 10.0722 1.45564 9.98428 1.54354C9.89637 1.63145 9.84699 1.75068 9.84699 1.875V2.8125L8.15011 1.19004C7.99132 1.02949 7.75519 0.9375 7.50001 0.9375C7.24572 0.9375 7.01017 1.02949 6.85138 1.19033L0.619933 7.15225C0.437706 7.32803 0.414855 7.61719 0.580675 7.80762C0.622315 7.85569 0.673301 7.89478 0.730528 7.92251C0.787756 7.95025 0.85003 7.96605 0.913558 7.96896C0.977087 7.97186 1.04054 7.96181 1.10006 7.93941C1.15958 7.91702 1.21392 7.88274 1.25978 7.83867L7.33888 2.02969C7.3825 1.98796 7.44053 1.96468 7.50089 1.96468C7.56125 1.96468 7.61929 1.98796 7.6629 2.02969L13.7426 7.83867C13.8322 7.92456 13.9521 7.97143 14.0762 7.96901C14.2002 7.9666 14.3183 7.91509 14.4044 7.82578C14.5843 7.63946 14.5694 7.33184 14.3821 7.15283Z" fill="var(--primary)"></path></g><defs><clipPath id="clip0_397_432"><rect width="15" height="15" fill="white"></rect></clipPath></defs></svg>
                @for (location of window.location.pathname.split('/'); track $index ;let first = $first) {
                  @if(!first){<span class="text-primary font-bold text-large">></span>}@if(location){<div class="font-semibold text-large text-primary first-letter:uppercase"> {{location}}</div>}
                }
              </div>
              <div
                (click)="changeMenu()"
                class="ml-auto flex h-8 mr-4 items-center md:hidden place-content-center rounded-full top-[24px] w-8"
                style="background: var(--primary);"
                >
                <svg
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="fill: white;"
                  >
                  <path
                    d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="h-[calc(100vh-80px)] overflow-y-scroll hide-bar"
          [ngClass]="{
            'w-screen md:w-[calc(100vw-221px)]': isMenuOpen,
            'w-screen md:w-[calc(100vw-90px)]': !isMenuOpen
          }"
              >
              <router-outlet></router-outlet>
            </div>
          </div>
          <div class="hidden text-tertiary"></div>
        </div>
      }
    </div>`,
  styles: [],
  standalone: false,
})
export class PagesComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private translocoService: TranslocoService
  ) {}
  window = window
  logged = false;
  currentBreadcrumb: any = null;
  userInfo = { username: "Profilo" };
  menuItems: SidenavInterface[] = [];
  isMenuOpen = window.innerWidth > 768;
  userData: any = {};

  ngOnInit(): void {
    if (localStorage.getItem("token")) {
      this.getMe();
    } else {
      // localStorage.clear();
      // window.location.replace("login");
    }
  }

  changeMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  menuChanged(menuExpanded: boolean) {
    this.isMenuOpen = menuExpanded;
  }

  getMe() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.menuItems = [];
      if (this.router.config[1].children) {
        this.router.config[1].children.forEach((path:any) => {          
          if(path?.data?.showSideNav && path?.data?.route){
          this.menuItems.push({
            text: path.title,
            route: '/manager/'+path.path,
            iconUrl: "../assets/employee.svg",
          });}
        });
      }
      this.menuItems.push({
            text: 'Disponibilità',
            route: '/manager/disponibilita',
            iconUrl: "../assets/employee.svg",
          })
      this.logged = true;
    });
  }
  // getBreadCrumb() {
  //   let breadcrumb: any =
  //     this.router.routerState?.root?.children[0]?.children[0];

  //   if (breadcrumb) {
  //     if (
  //       breadcrumb.data?._value?.currentElement ||
  //       breadcrumb.data?._value?.currentElement == 0
  //     ) {
  //       this.currentBreadcrumb = breadcrumb.data?._value?.currentElement;
  //     } else {
  //       this.currentBreadcrumb = null;
  //     }
  //     return breadcrumb.data?._value?.breadcrumb;
  //   } else {
  //     return [];
  //   }
  // }

  goTo(menuItem: any) {
    this.router.navigate([menuItem.route]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
  goToHome(){
    window.location.replace('')
  }
  userClick() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.router.navigate(['manager/profilo']);
      this.logged = true;
    });
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
}
